import {
  Entity,
  PrimaryKey,
  Property,
  ManyToOne,
  Unique,
} from '@mikro-orm/core';
import { User } from './user.entity';
import { Program } from './program.entity';
import { ProgramType } from './program-type.entity';
import { Rel } from '@mikro-orm/core';

@Entity({ tableName: 'user_programs' })
@Unique({ properties: ['user', 'program', 'programType'] })
export class UserProgram {
  @PrimaryKey()
  id!: number;

  @ManyToOne(() => User)
  user!: Rel<User>;

  @ManyToOne(() => Program)
  program!: Program;

  @ManyToOne(() => ProgramType)
  programType!: ProgramType;

  @Property({ type: 'datetime' })
  created_at: Date = new Date();

  @Property({ type: 'datetime', onUpdate: () => new Date() })
  updated_at?: Date = new Date();

  @Property({ type: 'datetime', nullable: true })
  deleted_at?: Date | null = null;
}
